module.exports = __webpack_public_path__ + "static/media/gb.521ff917.svg";